module.exports = __webpack_public_path__ + "img/footer_store_apple.40e0dc7.png";